import styled from "styled-components";

export const StyledImageNoFeedback = styled.svg.attrs({
  width: "131",
  height: "137",
  viewBox: "0 0 131 137",
  fill: "none",
})``;
